<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-history_statements'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      id="royalty-contracts-sidewindow-history_statements-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('statements')">
            <div class="ut-fc">
              <span class="txtov" :title="item['start_date']">
                {{ item["start_date"] }}
              </span>
              <span class="txtov" :title="item['end_date']">
                {{ item["end_date"] }}
              </span>
            </div>
          </td>
          <!-- <td v-bind="tdcon('end_date')">
            <span class="txtov" :title="item['end_date']">
              {{ item["end_date"] }}
            </span>
          </td> -->
          <td v-bind="tdcon('opening')">
            <span class="txtov" :title="item['opening_contract_all']">
              {{ item["opening_contract_all"] }}
            </span>
          </td>
          <td v-bind="tdcon('advances')">
            <span class="txtov" :title="item['advances']">
              {{ item["advances"] }}
            </span>
          </td>
          <td v-bind="tdcon('deductions')">
            <span class="txtov" :title="item['deductions_contract']">
              {{ item["deductions_contract"] }}
            </span>
          </td>
          <td v-bind="tdcon('physical')">
            <span class="txtov" :title="item['roy_physical']">
              {{ item["roy_physical"] }}
            </span>
          </td>
          <td v-bind="tdcon('reserves')">
            <div class="ut-fc">
              <span class="txtov" :title="item['return_reserve_amount']">
                {{ item["return_reserve_amount"] }}
              </span>
              <span class="txtov" :title="item['credit_reserve']">
                {{ item["credit_reserve"] }}
              </span>
            </div>
          </td>
          <!-- <td v-bind="tdcon('credit_reserve')">
            <span class="txtov text-right" :title="item['credit_reserve']">
              {{ item["credit_reserve"] }}
            </span>
          </td> -->
          <td v-bind="tdcon('digital')">
            <span class="txtov" :title="item['roy_digital']">
              {{ item["roy_digital"] }}
            </span>
          </td>
          <td v-bind="tdcon('licensing')">
            <span class="txtov" :title="item['roy_licensing']">
              {{ item["roy_licensing"] }}
            </span>
          </td>
          <td v-bind="tdcon('statement')">
            <span class="txtov" :title="item['payment_net_all']">
              {{ item["payment_net_all"] }}
            </span>
          </td>
          <td v-bind="tdcon('closing')">
            <span class="txtov" :title="item['closing_contract_all']">
              {{ item["closing_contract_all"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedContractDetails"],
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 44,
        headerHeight: 32,
        fullHeight: true
      })
    };
  },
  computed: {
    list: function() {
      return this.selectedContractDetails.statements || [];
    },
    headers: function() {
      return [
        createTableHeader("statements", { f: 1.2 }),
        // createTableHeader("end_date", { f: 0.7, text: false }),
        createTableHeader("opening", { ta: "right" }),
        createTableHeader("advances", { ta: "right" }),
        createTableHeader("deductions", { ta: "right" }),
        createTableHeader("physical", { ta: "right" }),
        createTableHeader("reserves", { ta: "right" }),
        // createTableHeader("credit_reserve", {
        //   f: 0.6,
        //   ta: "right",
        //   text: false
        // }),
        createTableHeader("digital", { ta: "right" }),
        createTableHeader("licensing", { ta: "right" }),
        createTableHeader("statement", { ta: "right" }),
        createTableHeader("closing", { ta: "right" })
      ];
    }
  }
};
</script>
<style lang="scss">
.royalty-contracts-sidewindow-history_statements-list {
  tbody {
    td {
      justify-content: flex-start;
    }
  }
}
</style>
